import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';

import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-support',
  templateUrl: './support.page.html',
  styleUrls: ['./support.page.scss'],
})
export class SupportPage implements OnInit {

  constructor( public platform: Platform, private router:Router) {}
  ngOnInit() {
  }

  mail(){

  }

  ionViewWillEnter(){
    this.platform.backButton.subscribeWithPriority(1, () => {
      this.router.navigate(['/tabs/tab5']);
    });
  
  }

  privacypolicy(){
    
  }

  terms(){
    
  }

}
